<template>
  <!-- Vive dentro de la celda de cabecera para heredar su alineación por columna -->
  <select
    v-if="definition.type === 'select'"
    class="mt-1.5 block w-full min-w-0 max-w-full border border-[#B9D3DA] text-[#385660] text-xs font-normal normal-case rounded-lg px-2 py-1.5 bg-white outline-none focus:border-[#42A9C2]"
    :value="modelValue ?? ''"
    :aria-label="label"
    @change="$emit('change', { value: $event.target.value, immediate: true })"
  >
    <option value="">{{ $t('search.all') }}</option>
    <option v-for="option in definition.options" :key="option.value" :value="option.value">
      {{ option.label }}
    </option>
  </select>

  <!-- Selector nativo: envía yyyy-mm-dd, que la API entiende -->
  <input
    v-else-if="definition.type === 'date'"
    type="date"
    class="mt-1.5 block w-full min-w-0 max-w-full border border-[#B9D3DA] text-[#385660] text-xs font-normal normal-case rounded-lg px-2 py-1.5 bg-white outline-none focus:border-[#42A9C2]"
    :value="modelValue ?? ''"
    :aria-label="label"
    @change="$emit('change', { value: $event.target.value, immediate: true })"
  />

  <input
    v-else
    type="text"
    class="mt-1.5 block w-full min-w-0 max-w-full border border-[#B9D3DA] text-[#385660] text-xs font-normal normal-case rounded-lg px-2 py-1.5 bg-white outline-none focus:border-[#42A9C2]"
    :value="modelValue ?? ''"
    :placeholder="$t('search.filterPlaceholder')"
    :aria-label="label"
    @input="$emit('change', { value: $event.target.value, immediate: false })"
  />
</template>

<script setup>
import { defineEmits, defineProps } from 'vue';

defineProps({
  // { key, type: 'text' | 'date' | 'select', options?: [{ value, label }] }
  definition: { type: Object, required: true },
  modelValue: { type: String, default: '' },
  label: { type: String, default: '' },
});

defineEmits(['change']);
</script>
